import React from 'react'
import OrganizationContainer from './OrganizationContainer'

export default class App extends React.Component {
  render() {
    return (
      <div id="body_section">
        <OrganizationContainer />
      </div>
    )
  }
}
